var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.072 25v-5.672a1.62 1.62 0 0 0-1.62-1.62h-.43a1.62 1.62 0 0 0-1.621 1.62V25",
    stroke: "#E5A033"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#1C1A37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.928 11.124V25H23.22V11.124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.993 13.074 1 25 12.846"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.9604e3a2a13667e62f92b987ace70237.svg";
export { ForwardRef as ReactComponent };